import {useToast} from 'vue-toastification'
import {Modal} from 'bootstrap'
import useApi from "@/composables/useApi";

export default function useDefineProductivityRepresentations() {
    const toast = useToast()
    const MODAL_ID = 'modalId'
    const {fetchResource, createResource, updateResource, deleteResource} = useApi()

    const baseStructure = {
        definition: '', purpose: '', formulas: []
    }

    const getModal = (modalId = null) => Modal.getOrCreateInstance(document.getElementById((modalId || MODAL_ID)))

    const data = () => ({
        items: [],
        newItem: structuredClone(baseStructure),
        editedItem: null,
        editIndex: null,
        showFormulaModal: false,
        editedFormulaItem: null,
        editFormulaIndex: null,
        profits: [],
        tableHeaders: ['تعریف نماگر', 'هدف نماگر'],
        tableFields: ['definition', 'purpose'],
    })

    const methods = {
        validateItem(item) {
            if (!item.definition || !item.purpose) {
                toast.error('همه فیلدها را کامل وارد کنید!')
                return false
            }
            return true
        },

        async fetchData() {
            const mainResponse = await fetchResource('/v2/finance-and-productivity/productivity-representations')
            this.items = mainResponse.data
            const profitsResponse = await fetchResource('/v2/finance-and-productivity/productivity-representations/get-profit-and-loss-structures')
            this.profits = profitsResponse.data
        },

        async addItem() {
            if (!this.validateItem(this.newItem)) return

            const response = await createResource('/v2/finance-and-productivity/productivity-representations', this.newItem)

            this.items.unshift(response.data)
            Object.assign(this.newItem, baseStructure)
        },

        async removeItem(index) {
            const deletedItem = this.items.find((_, i) => i === index);
            await deleteResource('/v2/finance-and-productivity/productivity-representations/' + deletedItem.id)
            this.items = this.items.filter((_, i) => i !== index)
        },

        async startEditing(item, index) {
            this.editedItem = structuredClone(item)
            this.editIndex = index
        },

        async editItem() {
            if (!this.validateItem(this.editedItem) || this.editIndex === null) throw new Error();

            const response = await updateResource('/v2/finance-and-productivity/productivity-representations/' + this.editedItem.id, this.editedItem)

            this.items.splice(this.editIndex, 1, response.data)
            this.editIndex = null
            this.editedItem = null
        },

        async openEditModal(item, index) {
            await this.startEditing(item, index)
            getModal().show()
        },

        async handleUpdate() {
            try {
                await this.editItem()
                getModal().hide()
            } catch (error) {
                console.log(error)
            }
        },

        async startCompletingFormulaItem(item, index) {
            this.editedFormulaItem = structuredClone(item)
            this.editFormulaIndex = index
            this.showFormulaModal = true
        },

        async openCompleteFormulaModal(item, index) {
            await this.startCompletingFormulaItem(item, index)
            getModal('formulaModalId').show()
        },

        async saveFormulas() {
            const url = '/v2/finance-and-productivity/productivity-representations/' + this.editedFormulaItem.id
            const response = await updateResource(url, this.editedFormulaItem)

            const editIndex = this.items.findIndex(item => item.id === this.editedFormulaItem.id)
            if (editIndex > -1) this.items.splice(editIndex, 1, response.data)

            getModal('formulaModalId').hide()
            this.showFormulaModal = false
        },
    }

    return {
        data, methods,
    }
}
